import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const financialAdvisorClientListing = async (page, query, limit = 10, active = null, body = {}) => {
  let url = `${ROUTES.GET_AVISOR_CLIENT_LISTING}?page=${page}&limit=${limit}`;
  if (query && query.trim() !== "") {
    url += `&name=${query}`;
  }
  if (active !== null) {
    url += `&isActive=${active}`;
  }
  let res = await FETCH.post({
    url: url,
    body: body,
  });
  return res;
};

const deletefinancialAdvisorClient = async (id,action) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_ADVISOR_CLIENT}?id=${id}&action=${action}`,
  });
  return res;
};

const activateFinancialAdvisorClient = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.ACTIVATE_FINANCIAL_ADVISOR_CLIENT,
    body,
  });
  return res;
};

const deactivateFinancialAdvisorClient = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.DEACTIVATE_FINANCIAL_ADVISOR_CLIENT,
    body,
  });
  return res;
};

const offboardFinancialAdvisorClient = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.OFFBOARD_FINANCIAL_ADVISOR_CLIENT || "/financial-advisor/offboard-client", // Fallback if route not defined
    body,
  });
  return res;
};

const refreshClientData = async (page, query) => {
  let res = await FETCH.get({
    url: `${ROUTES.REFRESH_CLIENT_DATA}`,
  });
  return res;
};

const FINANCIAL_ADVISOR_API = {
  financialAdvisorClientListing,
  deletefinancialAdvisorClient,
  activateFinancialAdvisorClient,
  deactivateFinancialAdvisorClient,
  offboardFinancialAdvisorClient,
  refreshClientData
};

export default FINANCIAL_ADVISOR_API;
